export const choiseMethodSizes = {
  l: 'l',
  s: 's',
}

export const chioseMethodPaddingsRem = {
  [choiseMethodSizes.l]: '1rem',
  [choiseMethodSizes.s]: '0.75rem 1rem',
}

export const chioseMethodPaddingsPx = {
  [choiseMethodSizes.l]: '16px',
  [choiseMethodSizes.s]: '12px 16px',
}

export const chioseMethodBorderRadiusesRem = {
  [choiseMethodSizes.l]: '1.25rem',
  [choiseMethodSizes.s]: '1.25rem',
}

export const chioseMethodBorderRadiusesPx = {
  [choiseMethodSizes.l]: '20px',
  [choiseMethodSizes.s]: '20px',
}
